"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    LockSlashSolid: function() {
        return LockSlashSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const LockSlashSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsxs)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M21.9519 20.5377L22.7071 21.2929C23.0976 21.6834 23.0976 22.3166 22.7071 22.7071C22.3166 23.0976 21.6834 23.0976 21.2929 22.7071L1.29289 2.70711C0.902369 2.31658 0.902369 1.68342 1.29289 1.29289C1.68342 0.902369 2.31658 0.902369 2.70711 1.29289L6.36064 4.94642C7.19925 2.64407 9.40763 1 12 1C15.3137 1 18 3.68629 18 7V9H19C20.6569 9 22 10.3431 22 12V20C22 20.1836 21.9835 20.3633 21.9519 20.5377ZM10.4142 9H16V7C16 4.79086 14.2091 3 12 3C9.92414 3 8.21761 4.5813 8.01925 6.60504L10.4142 9Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M2 12C2 10.4128 3.23259 9.11348 4.79278 9.00704L11 15.2143V17C11 17.5523 11.4477 18 12 18C12.4855 18 12.8902 17.654 12.981 17.1952L18.7857 23H5C3.34315 23 2 21.6569 2 20V12Z",
            fill: "currentColor"
        })
    ]
}), "LockSlashSolid");
const _default = LockSlashSolid;
